import styled from 'styled-components'
import { styledComponentWithProps, BaseButton } from '../../Styled/Shared'

type ButtonProps = {
  color: string
}

export const AlertContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1100;
`

export const AlertContent = styled.div`
  width: 450px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  z-index: 1200;
  box-shadow: 0 0 19px rgba(0, 0, 0, 0.18);

  .topbar {
    width: 100%;
    height: 50px;
    background: ${({ theme }) => theme.modal.alert.topBar};
  }

  .content {
    width: 100%;
    height: 100%;
    position: relative;
    justify-content: center;
    text-align: center;
    margin-top: 25px;
    margin-bottom: 35px;
  }

  .alert-icon {
    width: 80px;
    padding-bottom: 15px;
    margin-right: -2px; /* The svg isnt completely centered */
  }

  h2 {
    font-size: 20px;
    font-weight: bolder;
    color: black;
    padding: 0 20px 15px 20px;
  }

  h4 {
    font-size: 16px;
    line-height: 22px;
    color: gray;
    padding: 0 30px 30px 30px;
  }
`

export const AlertButton = styledComponentWithProps<ButtonProps>(
  styled(BaseButton)
)`
  background: ${({ color, theme }) =>
    color === 'green'
      ? theme.uiElements.primaryButton.background
      : theme.colors.light};
  min-width: auto;
  width: 100px;
  height: 3.2em;
  font-weight: normal;
  font-size: 15px;
  margin: 5px;

  &:hover {
    background: ${({ color, theme }) =>
      color === 'green' ? theme.hoverColors.brand : theme.project.button.hover};
  }

  &:active {
    transform: none;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Shared/Alerts/AlertStyles.tsx